import * as React from "react";

import { LongPressActionBubbleStyle } from "./long-press-action-bubble-style";
import ElementTrackingPortal from "../element-tracking-portal/element-tracking-portal";

interface Props {
    readonly target: React.RefObject<HTMLElement>;
    readonly label: string;
    readonly onClick: () => void;
    readonly onClose: () => void;
}

interface State {
    readonly hover: boolean;
}

export default class LongPressActionBubble extends React.PureComponent<Props, State> {
    public state = { hover: false };

    private onClick = (e: React.MouseEvent | React.TouchEvent) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onClick();
    };

    private onEnter = () => {
        if (!this.state.hover) {
            this.setState({ hover: true });
        }
    };

    private onLeave = () => {
        if (this.state.hover) {
            this.setState({ hover: false });
        }
    };

    public render(): React.ReactNode {
        const { label, target, onClose } = this.props;

        return (
            <ElementTrackingPortal targetRef={target} onClose={onClose}>
                {p => {
                    const orientation = p.targetY < 150 ? "below" : "above";
                    return (
                        <LongPressActionBubbleStyle
                            hover={this.state.hover}
                            isAbove={orientation === "above"}
                            className={"lpab-wrapper"}>
                            {orientation === "below" && <div className="lpab-top-triangle" />}
                            <div
                                className="lpab-bubble-general lpab-bubble-full"
                                onClick={this.onClick}
                                onMouseEnter={this.onEnter}
                                onTouchStart={this.onEnter}
                                onMouseLeave={this.onLeave}
                                onTouchEnd={this.onLeave}
                                onTouchCancel={this.onLeave}>
                                <div className="lpab-message">{label}</div>
                            </div>
                            {orientation === "above" && <div className="lpab-bottom-triangle" />}
                        </LongPressActionBubbleStyle>
                    );
                }}
            </ElementTrackingPortal>
        );
    }
}
